module.exports = __webpack_public_path__ + "static/media/20180529_184022.d4aa3bba.jpg";